import { ItemOption } from 'components/FormInputSelect'
import { useCallback, useEffect, useState } from 'react'
import genericService from 'services/generic.service'

type SelectOptionFields = {
  genderOptions: ItemOption[]
  skinOptions: ItemOption[]
  educationLevelOptions: ItemOption[]
  docTypeOptions: ItemOption[]
  infractionOptions: ItemOption[]
}

const selectFieldsInit: SelectOptionFields = {
  genderOptions: [],
  skinOptions: [],
  educationLevelOptions: [],
  docTypeOptions: [],
  infractionOptions: [],
}

const selectRequests = [
  '/genero',
  '/raca-cor',
  '/grau-escolaridade',
  '/tipo-documento',
  '/tipo-ato-infracional',
]

export const useInputSelectIdentification = () => {
  const [inputSelect, setInputSelect] = useState(selectFieldsInit)

  const fillInputSelect = useCallback(async (): Promise<void> => {
    try {
      const requestData = await Promise.all(
        selectRequests.map((url) => genericService.get(url).then((res) => res.data)),
      )

      const [
        resGenderOptions,
        resSkinOptions,
        resEducationLevelOptions,
        resDocTypeOptions,
        resInfractionOptions,
      ] = requestData

      setInputSelect({
        ...inputSelect,
        genderOptions: resGenderOptions,
        skinOptions: resSkinOptions,
        educationLevelOptions: resEducationLevelOptions,
        docTypeOptions: resDocTypeOptions,
        infractionOptions: resInfractionOptions,
      })
    } catch (err) {
      console.error('Input select Requests: ', err)
    }
  }, [inputSelect])

  useEffect(() => {
    fillInputSelect()
  }, [])

  return inputSelect
}
